export const MessageLocation = Object.freeze({
  FOOTER: 0,
  FULL_SCREEN_PAGED: 1,
  FULL_SCREEN_STATIC: 2,
  EMERGENCY: 3,
});
